import {ClickAwayListener} from '@mui/material';
import React from 'react';

type MouseEventType = 'onMouseDown';

export const EClickAwayListener = (props: {
  children: React.ReactElement<
    unknown,
    string | React.JSXElementConstructor<unknown>
  >;
  onClickAway: (event: MouseEvent | TouchEvent) => void;
  mouseEvent: MouseEventType;
}): React.ReactElement => <ClickAwayListener {...props} />;
